/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-comment-textnodes */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';
import { Avatar } from '@mui/material';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import SettingsIcon from '@mui/icons-material/Settings';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ChatIconButton from './ChatIconButton';
import { useHeaderV2Flag } from 'components/studentActionBar/HeaderV2Gate';
import { Dropdown, ButtonGroup, Spinner } from 'react-bootstrap';
import toast from 'react-hot-toast';
import { routers } from 'router/router';
import { useHistory, useLocation } from 'react-router';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { 
  getUserId, 
  getAccessToken, 
  //removeAccessToken, removeUserId 
} from 'utils/sessionStorage';
import basicInformationServices from 'services/basicInformationApi';
import { FileToBase64 } from 'components/helper/helper';
import { STRIPE_PRICE_NAME, STRIPE_SUBSCRIPTION_STATUS, USER_ROLE } from 'constants/common';
import { catName } from 'components/helper/helper';
import { getCurrentBasicDetail, getStripeSubscription, getStripeSubscriptionInfo, logout } from 'app/basicInformationSlice/basicInformationSlice';
import { getStudent } from 'app/authorization/authorizationSlice';
import PaymentServices from 'services/payment';
import { goToTrialEndedPayment, isCanceledTrial } from 'utils/trialPayment';

export const CalcTrialDays = (subcription:any) => {
  if (subcription) {
    let trial_end  =  new Date(subcription.trial_end * 1000);
    let d = trial_end.getTime() - new Date().getTime();
    return Math.round (d / (1000 * 3600 * 24)); 
  }
  return 0;
}

export const renderTrialMessage = (subcription:any) => {
  let d = CalcTrialDays(subcription);
  if (d === 1) {
    return ` ${d} day until your trial is up. `;
  }
  else {
    return ` ${d} days until your trial is up. `;
  }
}

interface Props {
  title: string;
}
const Header = (props: Props) => {
  const dispatch:any = useAppDispatch();
  let history:any = useHistory();
  const [profilePicture, setProfilePicture] = useState<any>();
  const [profileDescript, setprofileDescript] = useState('');
  const personalStore = useAppSelector((store) => store.basicInformation.myBasicInformation);
  const currentStudentId = useAppSelector((store) => store.basicInformation.currentStudentId);
  const myStripeSubscription = useAppSelector((store) => store.basicInformation.myStripeSubscription);
  const subscriptInfo = useAppSelector((store) => store.basicInformation.stripeSubscriptionInfo);
  const [displayName, setDisplayName] = useState('');
  const [stripeSubscription, setStripeSubscription] = useState<any>(null);
  const [paymentPlan, setPaymentPlan] = useState<any>(null);
  const [studentStripeSubscription, setStudentStripeSubscription] = useState<any>(null);
  const [studentSubscriptionInfo, setStudentSubscriptionInfo] = useState<any>(null);
  const [isTrialing, setIsTrialing] = React.useState(false);
  // trial_count (from getStudent) tells us whether this student ever actually
  // used a trial — needed so the "trial has ended" banner isn't shown to a
  // paying customer whose card simply failed (past_due/unpaid) or a brand-new
  // subscription still finalizing (incomplete), neither of which involved a trial.
  const [trialCount, setTrialCount] = React.useState(0);
  // Needed by the trial-ended Checkout Session (same data TrialExpiresDialog uses).
  const [studentEmail, setStudentEmail] = React.useState('');
  // Guards against double-clicking "Upgrade" while the Stripe url is being fetched.
  const [isUpgradeRedirecting, setIsUpgradeRedirecting] = React.useState(false);
  const fakeStudentId = `25${personalStore?.student_id ?? '00'}`;
  const role  = personalStore?.user_role ?? '';
  const location = useLocation();
  // Wait for header_v2 before choosing the chat entry, so the old header
  // bubble does not flash and then disappear.
  const counselorPage = location.pathname.match(/^\/application\/counselor\/([^/]+)/);
  const parentPage = location.pathname.match(/^\/dashboard\/student\/([^/]+)/);
  const actionBarStudentId =
    role === USER_ROLE.student ? personalStore?.student_id : counselorPage?.[1] || parentPage?.[1];
  const waitsForHeaderV2 =
    role === USER_ROLE.student || Boolean(counselorPage) || Boolean(parentPage);
  const { enabled: headerV2On, ready: headerV2Ready } = useHeaderV2Flag(actionBarStudentId, {
    waitForId: waitsForHeaderV2,
  });
  const showLegacyChat =
    !(role === USER_ROLE.counselor && counselorPage) &&
    (role === USER_ROLE.student || role === USER_ROLE.counselor || role === USER_ROLE.parent) &&
    headerV2Ready &&
    !headerV2On;

  React.useEffect(() => {
    const profilePictureName = personalStore?.profile_picture_file_name ?? null;
    const userRole: string = (personalStore?.user_role ?? '').toLowerCase()?.trim();
    if (profilePictureName) {
      basicInformationServices.getProfilePicture(profilePictureName).then(async (res) => {
        const blob = new Blob([res], { type: 'image/png;charset=utf-8' });
        const url = await FileToBase64(blob);
        setProfilePicture(url);
      });
    }

    if (userRole) {
      sessionStorage.setItem('userRole', role);
      setprofileDescript(userRole);
      if (userRole === USER_ROLE.student.toLowerCase()) {
        let s =
          personalStore && personalStore?.year_finish_high_school
            ? `Class of ${personalStore?.year_finish_high_school}`
            : '';
        setprofileDescript(s);
      } else if (userRole === USER_ROLE.counselor.toLowerCase()) {
        setprofileDescript('Counselor');
      } else {
        setprofileDescript(`Role: ${userRole}.`);
      }
    }
    setDisplayName(
      catName(personalStore?.first_name, personalStore?.middle_name, personalStore?.last_name)
    );
  }, [personalStore?.first_name, personalStore?.last_name, personalStore?.middle_name]);

  const handleLogout = (showMsg:boolean) => {
    dispatch(logout());
    if (showMsg) {
      toast.success("You have been successfully logged out!");
    }
    history.push(routers.login.path);
  };
  
  const getPlanName = (ret:any)=>{
    if (ret && ret.subcription_plan) {
        switch (ret.subcription_plan) {
          case STRIPE_PRICE_NAME.GradMapStarter:
            return "GradMap Starter";
          case STRIPE_PRICE_NAME.SilverMonth:
            return "Silver Monthly";
          case STRIPE_PRICE_NAME.SilverYear:
            return "Silver Monthly";
          case STRIPE_PRICE_NAME.GoldMonth:
            return "Gold Monthly";
          case STRIPE_PRICE_NAME.GoldYear:
            return "Gold Year";
          case STRIPE_PRICE_NAME.SilverPlusMonth:
            return "Silver Plus Monthly";
          case STRIPE_PRICE_NAME.SilverPlusYear:
            return "Silver Plus Monthly";
          default:
            return ''; //not applicable, not available
        }
    }
    return '';
  }

  async function getUserBillPortalUrl() {
    let returnUrl = `${window.location.origin}/#/settings?active-tab=5`;       
    let billUrl: any = await PaymentServices.getUserBillPortalUrl(returnUrl, personalStore.student_id);
    return billUrl;
  }

  async function getStudentBillPortalUrl(studentId: any) {
    if (!Number.isNaN(studentId)) {
      let returnUrl = `${window.location.origin}/#/application/counselor/${studentId}`;       
      let billUrl: any = await PaymentServices.getUserBillPortalUrl(returnUrl, studentId);
      return billUrl;
    }
    else{
      return '';
    }
  }

  const onClickUpgradeLink = async() => {
    // Trial ended (canceled + trial_count > 0): the Billing Portal cannot act on a
    // fully canceled subscription, so behave exactly like the "GO TO PAYMENT"
    // button in TrialExpiresDialog. Every other case keeps the normal flow below.
    const upgradeStatus = subscriptInfo?.subcription_status ?? paymentPlan?.subcription_status;
    if (isCanceledTrial(upgradeStatus, trialCount)) {
      if (isUpgradeRedirecting) return;
      setIsUpgradeRedirecting(true);
      await goToTrialEndedPayment({
        status: upgradeStatus,
        trialCount,
        planName: paymentPlan?.subcription_plan,
        studentId: personalStore?.student_id ?? getUserId(),
        studentEmail: studentEmail || personalStore?.email || '',
        history,
      });
      setIsUpgradeRedirecting(false);
      return;
    }

    if (paymentPlan?.subcription_plan === STRIPE_PRICE_NAME.GradMapStarter) {
      history.push(routers.upgradePlan.path);
      return;
    }

    let billUrl:any = await getUserBillPortalUrl();
    if (billUrl) {
      window.location.href = `${billUrl}`;
    }
  }

  const onClickStudentUpgradeLink = async() => {
    let billUrl:any = await getStudentBillPortalUrl(currentStudentId);
    if (billUrl) {
      window.location.href = `${billUrl}`;
    }
  } 

  async function getData() {
    let id = getUserId();
    let token = getAccessToken();
    try {
      if (token && id) {
        if (personalStore?.status !== 'loading') {
          try {
            const studentRes: any = await dispatch(getStudent(id)).unwrap();
            setTrialCount(studentRes?.trial_count ?? 0);
            setStudentEmail(studentRes?.email ?? '');
            await dispatch(getCurrentBasicDetail(id)).unwrap();
            let ss:any = await basicInformationServices.getStripeSubscription(id);
            setStripeSubscription(ss);
           
            if (!subscriptInfo) {
              let ssInfo = await dispatch(getStripeSubscriptionInfo(id)).unwrap();
              setPaymentPlan(ssInfo);
            } else {
              setPaymentPlan(subscriptInfo);
            }
          }
          catch(ex){
            // Backend will handle invalid tokens, no need to auto logout
            console.error('Error loading data:', ex);
          }
        }
      }
      // If no token/userId, just skip - backend will handle authentication
    }
    catch(ex){
      console.error('Error in getData:', ex);      
    }
  }

  // Sync từ Redux store khi có data
  React.useEffect(() => {
    if (myStripeSubscription) {
      setStripeSubscription(myStripeSubscription);
    }
  }, [myStripeSubscription]);

  React.useEffect(() => {
    if (subscriptInfo) {
      getData();
      setPaymentPlan(subscriptInfo);
      console.log('subscriptInfo:', subscriptInfo);
      // Re-derive on every change (not just set-once) so the banner clears/switches
      // correctly once the trial ends instead of getting stuck showing a countdown
      // with negative days.
      setIsTrialing(subscriptInfo?.subcription_status === STRIPE_SUBSCRIPTION_STATUS.trialing);
    }
  }, [subscriptInfo]);

  // Logout clears Redux (myBasicInformation/stripeSubscriptionInfo/myStripeSubscription
  // all become null), but the two effects above only ever ACT on a truthy value —
  // they never clear this component's own local state. Without this, whoever logs
  // in next on the same tab would briefly see the PREVIOUS student's plan name /
  // trial banner until their own fetch completes. Reset everything the moment
  // personalStore (myBasicInformation) goes null.
  React.useEffect(() => {
    if (!personalStore) {
      setStripeSubscription(null);
      setPaymentPlan(null);
      setStudentStripeSubscription(null);
      setStudentSubscriptionInfo(null);
      setIsTrialing(false);
      setTrialCount(0);
      setStudentEmail('');
    }
  }, [personalStore]);

  // "Trial has ended" is only true when the student actually USED a trial
  // (trial_count > 0) and Stripe's status reflects that the trial ran out
  // without payment. This intentionally mirrors TrialExpiresDialog's own
  // "trial" wording conditions (router/index.tsx):
  //   - canceled + trialCount>0  -> trial ended (canceled + trialCount===0 is a
  //     plain cancellation, unrelated to any trial)
  //   - unpaid                   -> dialog hardcodes trial-expired wording too
  // Deliberately EXCLUDED: past_due / paused / incomplete / incomplete_expired —
  // those can happen to an already-paying customer (failed card, new sub still
  // finalizing) with no trial involved, so labeling them "trial has ended" would
  // be incorrect/misleading.
  const currentStatus = subscriptInfo?.subcription_status;
  const hasTrialEnded =
    trialCount > 0 &&
    (currentStatus === STRIPE_SUBSCRIPTION_STATUS.canceled ||
      currentStatus === STRIPE_SUBSCRIPTION_STATUS.unpaid);

  React.useEffect(() => {
    if (role === USER_ROLE.student && personalStore?.student_id) {
      const id = getUserId();
      // Chỉ gọi nếu chưa có data hoặc student_id khác
      if ((!myStripeSubscription || !subscriptInfo) && id === personalStore.student_id) {
        getData();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [personalStore?.student_id, role]);

  const updateStudentInfo = async () => {
    if (role === USER_ROLE.parent && currentStudentId) {
      try {
        let ss:any=  await dispatch(getStripeSubscription(currentStudentId)).unwrap();
        setStudentStripeSubscription(ss);
        // Avoid writing child's Stripe status into global Redux (parent has no own subscription)
        const ssInfo = await basicInformationServices.getEnableExtention(currentStudentId);
        setStudentSubscriptionInfo(ssInfo);
      } catch(ex) {
        console.error('Error updating student info:', ex);
      }
    }
  }

  React.useEffect(() => {
    if (role === USER_ROLE.parent && currentStudentId) {
      updateStudentInfo();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentStudentId, role]);


  return (
    <div className="gm-topbar">
      <div className="w-100 d-flex gm-topbar-height justify-content-space">
        <div className="d-flex gm-topbar-height">
          <img
            src={'/assets/images/logo-color.svg'}
            alt="GradMap logo"
            style={{ alignSelf: 'center' }}
            height={48}
            className="d-inline mx-3 pl-3 pointer"
            onClick={() =>
              history.push({
                pathname: routers.dashBoard.path,
                search: `?role=${role}`,
              })
            }
          />
          <div className="d-inline border-end" style={{ width: '1px' }}></div>
          <div className="d-flex text-field-light h4 text-center pl-3" style={{ fontWeight: 600, alignSelf: 'center', margin: '8px' }}>
              {props.title}
          </div>
        </div>

        <div className="d-flex">
          {isTrialing && (
            <div className="d-flex text-danger text-center pl-3 align-self-center " style={{margin:'8px'}} >
              {`${renderTrialMessage(stripeSubscription)}`}
              {/* {!location.pathname.includes('/payment') && (
                <>
                &nbsp;<a href="/#/payment">Click here to subscribe!</a>
                </>
              )} */}
            </div>
          )}
          {!isTrialing && hasTrialEnded && (
            <div className="d-flex text-danger text-center pl-3 align-self-center" style={{margin:'8px'}}>
              Your trial has ended.
            </div>
          )}
        </div>

        <div className="d-flex justify-content-end align-items-center">
          {showLegacyChat && <ChatIconButton />}
          {personalStore?.user_role === USER_ROLE.student && (
            <>
            { paymentPlan ? (
            <span className="mx-3 text-left" style={{padding:'6px'}}>
              <span className="txt-info">Plan: {getPlanName(paymentPlan)}</span>
                  <span className="txt-info">. </span>
                  <span className="txt-info text-primary" style={{textDecoration: 'underline', cursor: 'pointer'}} onClick={onClickUpgradeLink} title='Upgrade Subcription Plan'>Upgrade </span>
              <br/><div className="txt-info text-field-light">GM ID: {fakeStudentId}</div>
            </span>
            ):(
              <span className="txt-info d-inline-flex align-items-center" role="status" aria-live="polite" aria-busy="true" style={{padding:'6px'}}>
                <Spinner animation="border" size="sm" className="me-1" />
                Checking plan...
              </span>
            )}
            </>
          )}
          {personalStore?.user_role === USER_ROLE.parent 
            && window.location.hash.includes('#/application/counselor/') && currentStudentId && (
            <>
            { studentStripeSubscription && studentSubscriptionInfo ?  (
            <span className="mx-3 text-left" style={{padding:'6px'}}>
            <span className="txt-info">Plan: {getPlanName(studentSubscriptionInfo)}</span>
                <span className="txt-info">. </span>
                <span className="txt-info text-primary" style={{textDecoration: 'underline', cursor: 'pointer'}} onClick={onClickStudentUpgradeLink} title='Upgrade Subcription Plan'>Upgrade </span>
            <br/><div className="txt-info text-field-light">Student GM ID: 25{studentStripeSubscription?.student_id ?? '00'} </div>
            </span>
            ):(
              <>
              <span className="txt-info d-inline-flex align-items-center" role="status" aria-live="polite" aria-busy="true" style={{padding:'6px'}}>
                <Spinner animation="border" size="sm" className="me-1" />
                Checking plan...
              </span>
              </>
            )}
            </>
          )}

          <span>
            <Avatar
              className="me-md-1"
              alt="sb-avatar"
              src={profilePicture}
              sx={{ width: 40, height: 40 }}
            />
          </span>
          <span>
            <Dropdown as={ButtonGroup} size="sm">
              <Dropdown.Toggle variant="white" id="dropdown-split-basic">
                <div className="d-flex">
                  <div className="text-start text-left">
                    {/* {displayEmail} */}
                    <span>{displayName}</span>
                    <div className="text-field-light">{profileDescript}</div>
                  </div>
                  <div className="icon-arrowdown">
                    <ArrowDropDownIcon sx={{ color: '#231F20' }}></ArrowDropDownIcon>
                  </div>
                  <div className="icon-arrowup">
                    <ArrowDropUpIcon sx={{ color: '#231F20' }}></ArrowDropUpIcon>
                  </div>
                </div>
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item onClick={() => history.push(routers.settings.path)}>
                  <SettingsIcon fontSize="small" className="mx-1" />
                  Settings
                </Dropdown.Item>
                <Dropdown.Item onClick={() => handleLogout(true)}>
                  <PowerSettingsNewIcon fontSize="small" className="mx-1" />
                  Logout
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </span>
        </div>
      </div>
      <style scoped>{`
      .dropdown-toggle::after {
        display: none !important;
      }
      .txt-info {
        font-size: 0.765625rem;
      }
      `}</style>
    </div>
  );
};

export default Header;
